module.exports = __webpack_public_path__ + "static/media/Sharp-ePoster-28.5-inch--PR-FINAL.4e6ee659.pdf";